import { isEmpty } from 'lodash'
import React from 'react'
import { t, Trans } from '@lingui/macro'
import EmptyEventSvg from 'public/assets/img/empty-event.svg'
import {
  EventModelAsStudent,
  TagModel
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { staticLinks } from 'shared/linkBuilder'
import { navigateTo } from 'front-end/src/app/util/appHistory'

import PageHeader from '../../../components/common/page/header/PageHeader'
import Loader from '../../../components/common/loader/Loader'
import EventGrid from '../../manage-events/components/event-grid/EventGrid'
import { ButtonOutline, Link } from 'front-end/src/components'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

interface IProps {
  events: Array<Partial<EventModelAsStudent>>
  tag: Partial<TagModel>
  loading: boolean
}

const EventsTagPagePresentation = (props: IProps) => {
  const { userIsAdminOrManager } = usePublicApiSession()

  const renderContent = () => {
    const { events, loading } = props

    if (loading) return <Loader />
    if (isEmpty(events)) {
      return (
        <div className="no-items">
          <img src={EmptyEventSvg} alt={t`Empty event`} />
          <h2>
            <Trans>This tag has no upcoming events</Trans>
          </h2>
          <p>
            <Trans>
              Head back to <Link to={staticLinks.events}>view all events</Link>
            </Trans>
          </p>
        </div>
      )
    }

    return <EventGrid events={events as any} />
  }

  const { tag } = props

  if (!tag) return <Loader />

  return (
    <>
      <PageHeader
        title={
          <>
            <em>
              <Trans>Events</Trans>:
            </em>
            {tag.name}
          </>
        }
        className="PageHeader"
        controls={
          <>
            {userIsAdminOrManager && (
              <ButtonOutline
                onClick={() => navigateTo(staticLinks.manageEvents)}
              >
                <Trans>Manage events</Trans>
              </ButtonOutline>
            )}
          </>
        }
      />
      {renderContent()}
    </>
  )
}

export default EventsTagPagePresentation
